module.exports = __webpack_public_path__ + "static/img/一加 13.e6928810.png";